
export default {

  props: ["element",'maxWidth'],
  name: "hyperMedia",
};
